import { useChatStore } from "../agent/chat/chat.store";
import { useAgentAttributesStore } from "../agent/store/agent-attributes.store";
import { useCallbackStore } from "./callback.store";
import { useSessionStore } from "./session.store";

/**
 * Drops the persisted session/task state that each channel rehydrates on load. Voice and chat used
 * to run on separate origins, so this state never crossed channels; now that they share one,
 * switching channels must not hand one channel's sessions to the other's orchestrator.
 */
export function clearPersistedWorkState() {
    useSessionStore.persist.clearStorage();
    useChatStore.persist.clearStorage();
    useCallbackStore.persist.clearStorage();
    useAgentAttributesStore.persist.clearStorage();
}
